import { render, staticRenderFns } from "./ShowComList.vue?vue&type=template&id=35d1c88e&scoped=true"
import script from "./ShowComList.vue?vue&type=script&lang=js"
export * from "./ShowComList.vue?vue&type=script&lang=js"
import style0 from "./ShowComList.vue?vue&type=style&index=0&id=35d1c88e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d1c88e",
  null
  
)

export default component.exports